import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import api from "../../services/api";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import { getMessagemErro } from "../../utils/erro";
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Tooltip } from "../UI/Tooltip/Tooltip";

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user
	}
}
const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

export const SecureDirectoryClientInformation =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				orgaoPossuiPastaSeguraConfigurada: true,
				sistemasOperacionais: [],
				ipsInternet: props.solicitacao.ipsInternet ? props.solicitacao.ipsInternet : "",
				so: props.solicitacao.so ? props.solicitacao.so : "",
			};
			
			this.handleInputChange = this.handleInputChange.bind(this);
		}

		render() {
			return (
				<div>
					{this.renderForm()}
				</div>
			);
		}

		componentDidMount(){
			const user = this.props.user;
			api.get(`/api/orgao/${user.idOrgao}/possui-pasta-segura-configurada`)
				.then(response => { 
					const orgaoPossuiPastaSeguraConfigurada = response.data;
					this.setState({ orgaoPossuiPastaSeguraConfigurada }) ;
					this.atualizaPropriedadesParent("orgaoPossuiPastaSeguraConfigurada", orgaoPossuiPastaSeguraConfigurada);

					if(orgaoPossuiPastaSeguraConfigurada){
						this.atualizaPropriedadesParent("ipsInternet", "");
						this.atualizaPropriedadesParent("so", "");
						this.atualizaPropriedadesParent("nomeSo", "");
					}

				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível verificar se o órgão possui pasta segura configurada.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				});

			api.get('/api/orgao/sistemas-operacionais-pasta-segura')
				.then(response => { 
					const sistemasOperacionais = response.data;
					this.setState({ sistemasOperacionais }) ;
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível carregar os sistemas operacionais.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				});	

		}

		renderForm() {
			const { solicitacao, readOnly } = this.props;
			const { ipsInternet, so } = this.state;
			const { orgaoPossuiPastaSeguraConfigurada, sistemasOperacionais } = this.state;

			return(
				<>
					{!orgaoPossuiPastaSeguraConfigurada &&
						<>
							<div className="mt-4 mb-4">
								<h2>Pasta Segura</h2>
							</div>
												
							<div className="br-form">
								<div className="row">
									<div className="col-md">
										<div className="field">
											<div className="input">
												<div className="d-flex">
													<label htmlFor="ipsInternet">IP's de Internet:&nbsp;</label>
													<Tooltip 
															content={
																<>
																	<span>Informar os IPs do servidor onde a pasta segura será instalada.</span>
																	<span>Não pode ser range de IPs.</span>
																	<span>Ex. 199.999.999.99, 198.888.888.88</span>
																</>
															}
														/>
												</div>
												<input type="text" name="ipsInternet" 
													value={ipsInternet}  
													onChange={this.handleInputChange} 
													readOnly={readOnly}
													maxLength="255"/>
											</div>
										</div>
									</div>
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="so">Sistema operacional da pasta segura:</label>
												{ !readOnly &&
													<SelectSearch
														id="so"
														name="so"
														options={sistemasOperacionais.map(sistema => ({ value: sistema.id, label: sistema.nome }))}
														onChange={this.handleInputChange}
														value={so}
														/>
												}
												{ readOnly &&
													<input type="text" name="nomeSo"  readOnly={readOnly}
														value={solicitacao.nomeSo ? solicitacao.nomeSo : ""}
													/>
												}
											</div>
										</div>
									</div>
								</div> 
								
							</div> 
						</>
					}
				</>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;
			this.setState({ [nome]: valor });

			this.atualizaPropriedadesParent(nome, valor);
		}

		atualizaPropriedadesParent(nome, valor) {
			const { onChangeProperties } = this.props;
			if (onChangeProperties) {
				onChangeProperties(nome, valor);
			}
		}

	}
	

) // redux
); // router